import {translations} from 'presentation/translations-new';
import {validateCEP} from 'presentation/utils';
import {z} from 'zod';

const {cep, checkWithoutNumber, addressName, city, district, uf, favoriteAddress} =
	translations['pt-br'].privateFlow.profile.changeData.addressErrors;

const OTHER_LABEL = 'Outro';

export const makeAddressDataSchema = (hasFavoriteAddressField = false) =>
	z
		.object({
			zipCode: z.string().refine(val => validateCEP(val), {
				message: cep,
			}),
			address: z.string().trim().min(1, addressName),
			number: z.string().trim(),
			complement: z.string().trim(),
			district: z.string().trim().min(1, district),
			state: z.string().trim().min(2, uf).max(2, uf),
			city: z.string().trim().min(1, city),
			withoutNumber: z.boolean().default(false),
			favoriteAddress: z.string().optional(),
		})
		.superRefine((values, ctx) => {
			if (!values.withoutNumber && !values.number) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['number'],
					message: checkWithoutNumber,
				});
			}

			if (
				hasFavoriteAddressField &&
				(!values.favoriteAddress || values.favoriteAddress === OTHER_LABEL)
			) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['favoriteAddress'],
					message: favoriteAddress,
				});
			}
		});

export const AddressDataSchema = makeAddressDataSchema();

export type AddressDataFormValues = z.infer<ReturnType<typeof makeAddressDataSchema>>;
